import BpkInput, {
  INPUT_TYPES,
} from '@skyscanner/backpack-web/bpk-component-input';

import FormField from '../FormField';

import DestinationSelector from './DestinationSelector';
import DestinationSelectorModal from './DestinationSelectorModal';

import type { AutosuggestSuggestionsOrPopularDestinations } from '../../types';
import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';
import type { Destination, ButtonClick } from '@shared/ui/types';

import { HASH_LOCATION_MODAL } from '@shared/constants/hash-routes';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import RouteLink from '@shared/ui/common/RouteLink';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  className?: Maybe<string>;
  inputClassName?: string;
  destinationLabel: string;
  destination?: Destination;
  suggestions: AutosuggestSuggestionsOrPopularDestinations;
  onChangeInputValue?: Maybe<Function>;
  onSuggestionsClearRequested: Function;
  onSuggestionSelected: Function;
  onSuggestionsFetchRequested: Function;
  lightLabel?: boolean;
  arrangeInline?: boolean;
  masonry?: boolean;
  valid?: Maybe<boolean>;
  hideLabel?: boolean;
};

const DESTINATION_INPUT_ID = 'destination-modal-input';

const DestinationSelectorContainer = ({
  arrangeInline,
  className,
  destination,
  destinationLabel,
  hideLabel,
  i18n,
  inputClassName,
  lightLabel,
  masonry,
  onChangeInputValue,
  onSuggestionSelected,
  onSuggestionsClearRequested,
  onSuggestionsFetchRequested,
  suggestions,
  valid,
}: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) =>
      isMobile ? (
        <>
          <RouteLink
            shouldGoBack={false}
            href={HASH_LOCATION_MODAL}
            onClick={() => {
              window.name = 'DVSearchModalIsOpen';
            }}
            render={(onClickLink: ButtonClick) => (
              <FormField
                fieldId={DESTINATION_INPUT_ID}
                label={destinationLabel}
                hideLabel={hideLabel}
                lightLabel
              >
                <BpkInput
                  id={DESTINATION_INPUT_ID}
                  name={DESTINATION_INPUT_ID}
                  className={inputClassName}
                  type={INPUT_TYPES.text}
                  value={destination?.entity ?? ''}
                  placeholder={i18n.translate(
                    'SearchControls_label_Destination_placeholder',
                  )}
                  onClick={onClickLink}
                  valid={valid}
                  readOnly
                />
              </FormField>
            )}
          />
          <DestinationSelectorModal
            className={className}
            destinationLabel={destinationLabel}
            destination={destination}
            arrangeInline={arrangeInline}
            onSuggestionSelected={onSuggestionSelected}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            suggestions={suggestions}
            cancelLabel={i18n.translate('Button_cancel')}
            onChangeInputValue={onChangeInputValue}
            valid={valid}
          />
        </>
      ) : (
        <DestinationSelector
          className={className}
          destinationLabel={destinationLabel}
          destination={destination}
          lightLabel={lightLabel}
          onSuggestionSelected={onSuggestionSelected}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          suggestions={suggestions}
          arrangeInline={arrangeInline}
          onChangeInputValue={onChangeInputValue}
          valid={valid}
          masonry={masonry}
          hideLabel={hideLabel}
        />
      )
    }
  </BpkBreakpoint>
);

export default withI18n(DestinationSelectorContainer);
